import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import PropTypes from 'prop-types';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import { Button,  Grid, Tooltip, Typography, InputLabel } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';


import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner';
import ServerError from '../ui/ServerError';
import Address from '../ui/Address'

import AccountUpdateMutation from '../account/AccountUpdateMutation';

const abEnvironment = new AbEnvironment();
const StepResellerAddressQuery = graphql`
query StepResellerAddressQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountNum
    accountName
    logo
    contactLastName
    contactFirstName
    contactEmail
    contactPhone
    address1
    address2
    city
    state
    country
    postalCode
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  accountLogo: {
    float: 'left',
    marginRight: 15
  },
  button: {
    width: 52,
  },
  input: {
    display: 'none',
  }
});

class StepResellerAddress extends React.Component {
  
  state = {
    country:    null,
    state:      null,
    city:       null,
    postalCode: null,
    address1:   null,
    address2:   null,
    showSpinner: false,

    forceFetch: 1
  }

  isAddressComplete(queryProps) {

    if (this.getValueForRender(this.state.address1,   queryProps.accountTByAccountId.address1, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.city,   queryProps.accountTByAccountId.city, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.state,   queryProps.accountTByAccountId.state, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.postalCode,   queryProps.accountTByAccountId.postalCode, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.country,   queryProps.accountTByAccountId.country, '') === '') {
      return false;
    }

    return true;
  }

  
  isInformationComplete(queryProps) {

    if (this.isAddressComplete(queryProps)) {
      return true;
    } else {
      return false;
    }
  }

  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    return false;
  }

  isNextDisabled(queryProps) {

    if (this.props.activeStep === this.props.assignedStep) {
      if (!this.isAddressComplete(queryProps)) {
        return true;
      } 
    }
    return false;
  }

  setCountry    = (country)    => { this.setState({country:    country}); }  
  setRegion     = (region)     => { this.setState({state:      region}); }  
  setCity       = (city)       => { this.setState({city:       city}); }  
  setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
  setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
  setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }


  showSpinner() {
    return this.state.showSpinner;
  }


  render() {
    const { logError } = this.props.auth;

    const classes = this.props.classes;

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    }
    
    let skipAllowed = false;
   
    let acctId = abEnvironment.getUserAttribute("a_id");

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={StepResellerAddressQuery}
        variables={{accountId: acctId, forceFetch: this.state.forceFetch}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {


            let address = {
              country:    this.getValueForRender(this.state.country,    props.accountTByAccountId.country,    ''),
              state:      this.getValueForRender(this.state.state,      props.accountTByAccountId.state,      ''),
              city:       this.getValueForRender(this.state.city,       props.accountTByAccountId.city,       ''),
              postalCode: this.getValueForRender(this.state.postalCode, props.accountTByAccountId.postalCode, ''),
              address1:   this.getValueForRender(this.state.address1,   props.accountTByAccountId.address1,   ''),
              address2:   this.getValueForRender(this.state.address2,   props.accountTByAccountId.address2,   '')
            };

            let logo = props.accountTByAccountId.logo;
  
            if (!displayOnly) {
              return (
        
                <Grid container spacing={2}  style={{marginTop: 8}}>
          
                  <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="flex-start">
                      <Grid item>
                        <Typography variant="body1">
                        Add your contact information to let your customers know it’s you when sending and managing orders.
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>                   
                      <div className={classes.accountLogo}>
                        { props.accountTByAccountId.logo != null &&
                          <div>
                            <Typography variant="body2" style={{fontWeight:600, marginTop:8, marginBottom:16}}>
                              Upload your logo
                            </Typography>
                            <input
                              accept="image/*"
                              className={classes.input}
                              id="upload-button"
                              type="file"
                              onChange={this.handleFileUpload}
                            />
                            <Tooltip title="Click to change logo">
                              <label htmlFor="upload-button">
                                <Button variant="text" component="span" className={classes.button}>
                                  <img alt="Logo" height="52px" src={props.accountTByAccountId.logo} />
                                </Button>
                              </label>
                            </Tooltip>
                          </div>
                        }

                        { props.accountTByAccountId.logo == null &&
                          <div>
                            <Typography variant="body2" style={{fontWeight:600, marginTop:8, marginBottom:16}}>
                              Upload your logo
                            </Typography>
                            <input
                              accept="image/*"
                              className={classes.input}
                              id="upload-button"
                              type="file"
                              onChange={this.handleFileUpload}
                            />
                            <Tooltip title="Click to add logo">
                              <label htmlFor="upload-button">
                                <Button variant="outlined" component="span" className={classes.button}>
                                  <img alt="Logo" height="48px" src={'/logos/add-logo-225.png'} />
                                </Button>
                              </label>
                            </Tooltip>
                          </div>
                        }
                      </div>

                  </Grid>

                  <Grid item xs={12}>                   
                    <Typography variant="body2" style={{fontWeight:600,marginTop:16}}>
                      What is your business address?
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{marginBottom: 16}}>
                    <Address
                      showRequired={false}
                      address={address}
                      regionLabel={"Region"}
                      setCountryCodeState={this.setCountry}
                      setRegionCodeState={this.setRegion}
                      setCityState={this.setCity}
                      setPostalCodeState={this.setPostalCode}
                      setAddress1State={this.setAddress1}
                      setAddress2State={this.setAddress2}
                    />
                  </Grid>


                  {this.props.activeStep === this.props.assignedStep &&
                  <Grid item xs={12}>
                    <Button
                      disabled={this.isBackDisabled()}
                      color="primary" variant="outlined"
                      onClick={() => this.props.handleBack()}
                      style={AppBindStyles.bottomButton}>
                      Back
                    </Button>

                    {!this.showSpinner() &&        
                    <Button
                      color="primary" variant="contained"
                      disabled={this.isNextDisabled(props)}
                      onClick={() => { this.updateBillingAddress(acctId);}}
                      style={AppBindStyles.bottomButton}>
                        Next
                    </Button>
                    }
                    {this.showSpinner() &&
                    <Button color="primary" 
                            variant="contained"
                            style={AppBindStyles.bottomButton}>
                        <SavingSpinner/>
                    </Button>
                    }

                    {skipAllowed &&
                      <Button
                        color="primary" variant="outlined"
                        onClick={() => { this.props.handleNext();}}
                        style={AppBindStyles.bottomButton}>
                        Skip
                      </Button>
                    }
                  </Grid>
                      
                  } 
                </Grid>       
              );
          
            } else {

              //display only
              return (
        
                <Grid container style={{marginTop: 8}}>
                  <React.Fragment>

                    { logo != null &&
                    <Grid item xs={12} style={{marginBottom:16}}>          
                        <InputLabel shrink style={{marginBottom:6}}>Logo</InputLabel>         
                        <div className={classes.accountLogo}>
                          <img alt="Logo" height="52px" src={props.accountTByAccountId.logo} />
                        </div>
                    </Grid>
                    }
                    <Grid item xs={12}>
                      <InputLabel shrink style={{marginBottom:6}}>Business address</InputLabel>
                      <Typography variant="body2">
                        {address.address1} {address.address2}<br/>
                        {address.city}, {address.state}, {address.country} {address.postalCode}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                </Grid>                  
              );
        
            }
          }
          if (!displayOnly) {
            return <div><LoadingSpinner/></div>
          }
        }
      }
      />
    );

  }

  handleFileUpload = event => {
    const { callPartnerApi, logError } = this.props.auth;

    // file upload needs to do something.
    let acctId = abEnvironment.getUserAttribute('a_id');
    let masqueradeAccountId = null;
    if (abEnvironment.isMasquerade()) {
      masqueradeAccountId = localStorage.getItem('m_a_id');
    }

    let theFile = event.target.files[0];
    if (!theFile) {
      return;
    }
    let theFilename = theFile.name;
    let theFiletype = theFile.type;
    let theFilesize = theFile.size;
    // alert('The file size is ' + theFilesize);
    if (theFilesize > 200000) {
      return;
    }

    // Call 
    let payload = {
      operation: "getSignedLogoUploadUrl",
      params: {
        filename: theFilename,
        filetype: theFiletype,
        masqAccountId: masqueradeAccountId
      }
    }
    
    callPartnerApi('appbind/generic',
                   'POST',
                   payload)
    .then((resp) => {
      return resp.json();
    })
    .then(theresp => {
      let theurl = theresp.data;
      return fetch(theurl, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': theFiletype,
        }),
        body: theFile
      });
    })
    .then(response => {
      // Call an update mutation to set on the account? Probably.
      // The file is being put in logoc/<aid>/fname - so set that on the account
      let theLogoPath = '/logoc/' + acctId + '/' + theFilename;
      return AccountUpdateMutation.commit(acctId, null, null, null, null,
                                          null, null, null, null,
                                          null, null, null, null, null, null,
                                          theLogoPath, null, null, null);

    })
    .then(mr => {
      // console.log(mr);
      //this will force the query to happen to display the logo
      let newForceFetch = this.state.forceFetch;
      newForceFetch++;
      this.setState({forceFetch: newForceFetch});
  
    })
    .catch(error => {
      // Notify that there was an error
      logError('Exception in StepResellerAddress.js: ' + error);
    });

  }

  updateBillingAddress = (acctId) => {

    const { address1, address2, city, state, country, postalCode } = this.state;

    if (address1 === null && address2 === null && city === null && state === null && country === null && postalCode === null) {
      this.props.handleNext();
      return;
    }

    this.setState({showSpinner: true});    
    AccountUpdateMutation.commit(acctId, null, null, null, null,
                                 null, null, null, null,
                                 address1, address2, city, state, country, postalCode,
                                 null, null, null, null, null, 
                                 null, null, null)
    .then(response => {

      //set the users company address. This normally gets set when logged on
      //but this is first time the user has stated their business address.
      abEnvironment.setUserAttribute('a_address1', address1);
      if (address2 != null) {
        abEnvironment.setUserAttribute('a_address2', address2);
      }
      abEnvironment.setUserAttribute('a_city', city);
      abEnvironment.setUserAttribute('a_state', state);
      abEnvironment.setUserAttribute('a_country', country);
      abEnvironment.setUserAttribute('a_postalCode', postalCode);
      this.setState({showSpinner: false});    
      this.props.handleNext();
     })
    .catch(error => {
      // console.log('Got error: ' + error);
      this.setState({showSpinner: false});    
    });
  }


}


StepResellerAddress.propTypes = {
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(StepResellerAddress);
